<template lang="pug">
  #establishment(
    v-if="establishment"
    :style="`--primary: ${primaryColor}`"
  )
    div.content(style="padding: 0 24px;")
      //- editable-title.establishment-name(
      //-   :value="establishment._name || 'Etablissement sans nom'"
      //-   @input="rename"
      //- )
      h3 Fiches validées
      valid-sheets(
        ref="validSheets"
        :establishment="establishment"
        :potential-establishments="potentialEstablishments"
        @hover="sheetHoverHandler"
        @getSheets="sheets => this.validSheetAggregates = sheets"
      )
      h3 Établissements potentiels
      potential-establishments(
        ref="potentialEstablishments"
        :establishment="establishment"
        @hover="establishmentHoverHandler"
        @getEstablishments="setPotentialEstablishments"
        @update="update"
      )
      h3 Rechercher une fiche pour l'ajouter au regroupements
      all-establishments-search(
        ref="allEstablishmentsSearch"
        :establishment="establishment"
        @hover="establishmentHoverHandler"
      )
    .establishment-map-wrapper
      establishment-map(
        ref="establishmentMap"
        :establishmentSheets="validSheetAggregates"
      )
</template>

<script>
import ValidSheets from '@/views/establishment/ValidSheets.vue';
import PotentialEstablishments from '@/views/establishment/PotentialEstablishments.vue';
import AllEstablishmentsSearch from '@/views/establishment/AllEstablishmentsSearch.vue';
import EstablishmentMap from '@/components/EstablishmentMap.vue';
import EditableTitle from '@/components/EditableTitle.vue';
import establishmentService from '@/services/establishments.js';

export default {
  components: {
    ValidSheets,
    PotentialEstablishments,
    AllEstablishmentsSearch,
    EstablishmentMap,
    EditableTitle,
  },
  props: {
    establishmentId: {
      type: String,
      required: true,
    },
    primaryColor: {
      type: String,
      default: '#025A94',
    },
  },
  data() {
    return {
      establishment: null,
      potentialEstablishments: [],
      mapOpen: true,
      editingName: false,
      validSheetAggregates: [],
    };
  },
  mounted () {
    this.getEstablishment();
  },
  methods: {
    update() {
      this.$refs.validSheets.getValidSheetAggregates();
      this.$refs.potentialEstablishments.getPotentialEstablishments();
      this.$refs.allEstablishmentsSearch.search(null);
    },
    async getEstablishment() {
      this.establishment = await establishmentService.getById(this.establishmentId);
    },
    sheetHoverHandler({ sheet }) {
      this.$refs.establishmentMap.hoverSheet(sheet);
    },
    establishmentHoverHandler({ establishment }) {
      this.$refs.establishmentMap.addEstablishmentMarkers(establishment);
    },
    setPotentialEstablishments({ establishments }) {
      this.potentialEstablishments = establishments;
    },
    // async rename(newName) {
    //   const newEstablishment = await establishmentService.rename(this.establishmentId, this.establishment, newName);
    //   if (newEstablishment) {
    //     this.establishment = newEstablishment;
    //   }
    // },
  },
}
</script>

<style lang="scss">
  #establishment {
    > .content {
      box-sizing: border-box;
      max-width: calc(100vw - 456px);
    }
    .establishment-map-wrapper {
      position: fixed!important;
      bottom: 0;
      top: 0;
      right: 0;
      display: flex;
      float: right;
      padding: 0 0 0 .5em;
      background: #EEEEEE;
      transform-origin: bottom right;
      transition: transform .5s ease-in-out;
      .establishment-map-close {
        position: absolute;
        height: 40px;
        width: 40px;
        background-color: var(--primary);
        z-index: 1;
        cursor: pointer;
        border-radius: 0 0 100% 0;
        top: 0;
        left: 0;
        i {
          color: white;
          position: absolute;
          top: 4px;
          left: 4px;
        }
      }
    }
    .establishment-map-open {
      position: fixed;
      height: 40px;
      width: 40px;
      background-color: var(--primary);
      z-index: 1;
      cursor: pointer;
      border-radius: 100% 0 0 0;
      bottom: 0;
      right: 0;
      transform-origin: bottom right;
      transition: transform .2s ease-in-out;
      transition-delay: .3s;
      &.hidden {
        transition-delay: 0s;
        transform: scale(0, 0);
      }
      i {
        color: white;
        position: absolute;
        right: 4px;
        bottom: 4px;
      }
    }
  }
</style>